import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createHandOver,
  deleteHandOver,
  getHandOver,
  updateHandOver,
  completedHandOver,
} from "libs/api/handover";

// HandOver Thunk
export const getHandOverThunk = createAsyncThunk(
  "handover/get",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    queryParams,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await getHandOver(pathname, queryParams);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// Create HandOver Thunk
export const createHandOverThunk = createAsyncThunk(
  "handover/create",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    body,
    accessToken,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await createHandOver(pathname, body, accessToken);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

export const completedHandOverThunk = createAsyncThunk(
  "handover/complete",
  async ({
    cbPending,
    cbFulfilled,
    cbRejected,
    cbFinally,
    pathname,
    body,
    accessToken,
  }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await completedHandOver(pathname, body, accessToken);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// Update HandOver Thunk
export const updateHandOverThunk = createAsyncThunk(
  "handover/update",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pathname, body }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await updateHandOver(pathname, body);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);

// Delete HandOver Thunk
export const deleteHandOverThunk = createAsyncThunk(
  "handover/delete",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, pathname }) => {
    try {
      typeof cbPending === "function" && cbPending();
      const response = await deleteHandOver(pathname);
      typeof cbFulfilled === "function" && cbFulfilled();
      return response;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  }
);
